/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    DataSource,
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    EventValidator,
    EventValidatorFromJSON,
    EventValidatorFromJSONTyped,
    EventValidatorToJSON,
    LogicModule,
    LogicModuleFromJSON,
    LogicModuleFromJSONTyped,
    LogicModuleToJSON,
    LogicModuleType,
    LogicModuleTypeFromJSON,
    LogicModuleTypeFromJSONTyped,
    LogicModuleTypeToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestConfigMilestone
 */
export interface QuestConfigMilestone {
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    id: string;
    /**
     * 
     * @type {LogicModuleType}
     * @memberof QuestConfigMilestone
     */
    logicType: LogicModuleType;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    targetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    sessionAmount?: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigMilestone
     */
    sessionCadence?: QuestReset;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    triggerEvent: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    resetEvent?: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    finishEvent?: EventValidator;
    /**
     * 
     * @type {Array<DataSource>}
     * @memberof QuestConfigMilestone
     */
    sources?: Array<DataSource>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigMilestone
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    gameId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    progressionOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    rewardPer?: number;
}

export function QuestConfigMilestoneFromJSON(json: any): QuestConfigMilestone {
    return QuestConfigMilestoneFromJSONTyped(json, false);
}

export function QuestConfigMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigMilestone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'logicType': LogicModuleTypeFromJSON(json['logicType']),
        'targetAmount': json['targetAmount'],
        'sessionAmount': !exists(json, 'sessionAmount') ? undefined : json['sessionAmount'],
        'sessionCadence': !exists(json, 'sessionCadence') ? undefined : QuestResetFromJSON(json['sessionCadence']),
        'triggerEvent': EventValidatorFromJSON(json['triggerEvent']),
        'resetEvent': !exists(json, 'resetEvent') ? undefined : EventValidatorFromJSON(json['resetEvent']),
        'finishEvent': !exists(json, 'finishEvent') ? undefined : EventValidatorFromJSON(json['finishEvent']),
        'sources': !exists(json, 'sources') ? undefined : ((json['sources'] as Array<any>).map(DataSourceFromJSON)),
        'rewardConfigIds': !exists(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'gameId': !exists(json, 'gameId') ? undefined : json['gameId'],
        'progressionOrder': !exists(json, 'progressionOrder') ? undefined : json['progressionOrder'],
        'rewardPer': !exists(json, 'rewardPer') ? undefined : json['rewardPer'],
    };
}

export function QuestConfigMilestoneToJSON(value?: QuestConfigMilestone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'logicType': LogicModuleTypeToJSON(value.logicType),
        'targetAmount': value.targetAmount,
        'sessionAmount': value.sessionAmount,
        'sessionCadence': QuestResetToJSON(value.sessionCadence),
        'triggerEvent': EventValidatorToJSON(value.triggerEvent),
        'resetEvent': EventValidatorToJSON(value.resetEvent),
        'finishEvent': EventValidatorToJSON(value.finishEvent),
        'sources': value.sources === undefined ? undefined : ((value.sources as Array<any>).map(DataSourceToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'name': value.name,
        'description': value.description,
        'gameId': value.gameId,
        'progressionOrder': value.progressionOrder,
        'rewardPer': value.rewardPer,
    };
}


